import React, { createContext, useState, useEffect } from "react";
import { get, getWithParams } from "../services/base";
import PropTypes from "prop-types";
import { extractPatientIdFromUrl } from "../utils/helpers";
import {
  getClinicResultsCode,
  getClinicResultsTypeCode,
  getTiposUnitCode,
  getUnitCode,
  obtenerListadoSustancias,
} from "../services/dim";
import { getPatientClinicResults } from "../services/api";

const MedicInformationContext = createContext();

const MedicInformationContextProvider = ({ children }) => {
  const [listadoMedicamentos, setMedicamentos] = useState([]);
  const [afiliadoMedicamentos, setAfiliadoMedicamentos] = useState([]);
  const [afiliadoComorbilidades, setAfiliadoComorbilidades] = useState([]);
  const [listadoViaAdministracion, setViaAdministracion] = useState([]);
  const [listadoTipos, setTipos] = useState([]);
  const [listadoTiposUnidades, setTiposUnidades] = useState([]);
  const [listadoUnidades, setUnidades] = useState([]);
  const [listadoSustancias, setSustancias] = useState(null);
  const [resultadosClinicos, setResultadosClinicos] = useState(null);
  const [codeResultadosClinicosType, setCodeResultadosClinicosType] = useState(
    []
  );
  const [unitCode, setUnitCode] = useState([]);
  var afiliado = extractPatientIdFromUrl();
  useEffect(() => {
    const fetchData = async () => {
      const dataMedicamentos = await getWithParams("/Medicamentos", {
        afiliado: extractPatientIdFromUrl(),
      });
      setMedicamentos(dataMedicamentos.data);

      const dataViaAdministracion = await get("/Medicamentos/via");
      setViaAdministracion(dataViaAdministracion.data);

      const dataTipos = await get("/Medicamentos/tipo");
      setTipos(dataTipos.data);


      const dataSustancias = await obtenerListadoSustancias();
      setSustancias(dataSustancias);

      const dataUnidades = await get("/Medicamentos/unidad");
      setUnidades(dataUnidades.data);

      const dataAfiliadoMedicamentos = await get(
        `/Medicamentos/yo?CodigoAfiliado=${extractPatientIdFromUrl()}`
      );
      setAfiliadoMedicamentos(dataAfiliadoMedicamentos.data);

      const dataAfiliadoCondiciones = await get(
        `/DatosClinicos/comorbilidades?afiliado=${extractPatientIdFromUrl()}`
      );
      setAfiliadoComorbilidades(dataAfiliadoCondiciones.data);

      
      const resultadosClinicosTypeCode = await getClinicResultsTypeCode();
      setCodeResultadosClinicosType(resultadosClinicosTypeCode);

      const unit = await getUnitCode();
      setUnitCode(unit);

      const TipoUnit = await getTiposUnitCode();
      setTiposUnidades(TipoUnit);

      const resultadosClinicos = await getPatientClinicResults(afiliado);
      setResultadosClinicos(resultadosClinicos);

    };

    fetchData();
  }, []);

  const updateMedicamentosData = async () => {
    try {
      const dataAfiliadoMedicamentos = await get(
        `/Medicamentos/yo?CodigoAfiliado=${extractPatientIdFromUrl()}`
      );
      setAfiliadoMedicamentos(dataAfiliadoMedicamentos.data);

      const dataMedicamentos = await getWithParams("/Medicamentos", {
        afiliado: extractPatientIdFromUrl(),
      });
      setMedicamentos(dataMedicamentos.data);
    } catch (error) {
      console.error(error);
    }
  };

  const updateCondiciones = async () => {
    try {
      const dataAfiliadoCondiciones = await get(
        `/DatosClinicos/comorbilidades?afiliado=${extractPatientIdFromUrl()}`
      );
      setAfiliadoComorbilidades(dataAfiliadoCondiciones.data);
    } catch (error) {
      console.error(error);
    }
  };

  const updateResultadosClinicos = async () => {
    try {
      const resultadosClinicos = await getPatientClinicResults(afiliado);
      setResultadosClinicos(resultadosClinicos);
    } catch (error) {
      console.error(error);
    }
  };

  const contextValue = {
    listadoMedicamentos,
    listadoViaAdministracion,
    listadoTipos,
    listadoUnidades,
    afiliadoMedicamentos,
    afiliadoComorbilidades,
    resultadosClinicos,
    codeResultadosClinicosType,
    unitCode,
    listadoTiposUnidades,
    listadoSustancias,
    updateMedicamentosData,
    updateResultadosClinicos,
    updateCondiciones,
  };
  return (
    <MedicInformationContext.Provider value={contextValue}>
      {children}
    </MedicInformationContext.Provider>
  );
};

MedicInformationContextProvider.propTypes = {
  children: PropTypes.node,
};

export { MedicInformationContext, MedicInformationContextProvider };
